import { InjectionToken } from "@angular/core";
import { BankAccountsPort } from "./bank-accounts.port";

export const BANK_ACCOUNTS_PORT = new InjectionToken<BankAccountsPort>(
  "BANK_ACCOUNTS_PORT",
);
